//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { TrackingId, TrackingIdPrefix } from '@models/TrackingId';

export const UIATrackingIdPrefix: TrackingIdPrefix = 'uia-';
export const UIADetailsTrackingIdPrefix: TrackingIdPrefix = `${UIATrackingIdPrefix}details-`;
export const UIADistributionTrackingIdPrefix: TrackingIdPrefix = `${UIATrackingIdPrefix}distribution-`;
export const UIARightsTrackingIdPrefix: TrackingIdPrefix = `${UIATrackingIdPrefix}rights-`;
export const UIALabelsTrackingIdPrefix: TrackingIdPrefix = `${UIATrackingIdPrefix}labels-`;
export const UIAProductsTrackingIdPrefix: TrackingIdPrefix = `${UIATrackingIdPrefix}products-`;
export const EditCaptionTrackingIdPrefix: TrackingIdPrefix = `${UIADetailsTrackingIdPrefix}edit-caption-`;
export const UIACoverImageTrackingIdPrefix: TrackingIdPrefix = `${UIATrackingIdPrefix}cover-image-`;
export const UIAShareTrackingIdPrefix: TrackingIdPrefix = `${UIATrackingIdPrefix}share-`;

export const UIATrackingIds = {
  COVER_IMAGE_EDIT_BUTTON: `${UIACoverImageTrackingIdPrefix}edit-button`,
  COVER_IMAGE_CONFIRM_BUTTON: `${UIACoverImageTrackingIdPrefix}confirm-button`,
  COVER_IMAGE_UPLOAD_BUTTON: `${UIACoverImageTrackingIdPrefix}upload-button`,

  DETAILS_EDIT_CAPTION_INPUT: `${EditCaptionTrackingIdPrefix}input`,
  DETAILS_EDIT_CAPTION_TOGGLE_ORIGINAL: `${EditCaptionTrackingIdPrefix}toggle-original`,
  DETAILS_EDIT_CAPTION_TRIGGER: `${EditCaptionTrackingIdPrefix}trigger`,
  DETAILS_OPEN_BADGE_LINK: `${UIADetailsTrackingIdPrefix}open-badge-link`,
  DETAILS_OPEN_LOCATION: `${UIADetailsTrackingIdPrefix}open-location`,
  DETAILS_OPEN_TAGGED_USER: `${UIADetailsTrackingIdPrefix}open-tagged-user`,
  DETAILS_OPEN_USER_WEB_LINK: `${UIADetailsTrackingIdPrefix}open-user-web-link`,

  DISTRIBUTION_APPROVE_FOR_FANREEL_OPTION: `${UIADistributionTrackingIdPrefix}approve-for-fanreel-option`,
  DISTRIBUTION_APPROVE_FOR_GALLERIES_OPTION: `${UIADistributionTrackingIdPrefix}approve-for-galleries-option`,
  DISTRIBUTION_APPROVE_FOR_SYNDICATION_OPTION: `${UIADistributionTrackingIdPrefix}approve-for-syndication-option`,
  DISTRIBUTION_MEDIA_LIBRARY_OPTION: `${UIADistributionTrackingIdPrefix}media-library-option`,
  DISTRIBUTION_ONE_PAGE_OPTION: `${UIADistributionTrackingIdPrefix}one-page-option`,
  DISTRIBUTION_REVEAL_OPTION: `${UIADistributionTrackingIdPrefix}reveal-option`,
  DISTRIBUTION_SHOWROOM_OPTION: `${UIADistributionTrackingIdPrefix}showroom-option`,
  DISTRIBUTION_SOCIAL_MEDIA_OPTION: `${UIADistributionTrackingIdPrefix}social-media-option`,

  LABELS_CLOSE_MODAL: `${UIALabelsTrackingIdPrefix}close-modal`,
  LABELS_CREATE_TAG: `${UIALabelsTrackingIdPrefix}create-tag`,
  LABELS_REMOVE_TAG: `${UIALabelsTrackingIdPrefix}remove-tag`,

  PRODUCTS_ADD_PRODUCT: `${UIAProductsTrackingIdPrefix}add-product`,
  PRODUCTS_CLOSE_MODAL: `${UIAProductsTrackingIdPrefix}close-modal`,
  PRODUCTS_PRODUCT_TAGS_CONTAINER: `${UIAProductsTrackingIdPrefix}product-tags-container`,
  PRODUCTS_PRODUCT_TAGS_EDIT: `${UIAProductsTrackingIdPrefix}product-tags-edit`,
  PRODUCTS_PRODUCT_TAGS_REMOVE: `${UIAProductsTrackingIdPrefix}product-tags-remove`,
  PRODUCTS_REEL_MODERATION: `${UIAProductsTrackingIdPrefix}reel-moderation`,
  PRODUCTS_SEARCH_PRODUCT_CATALOG: `${UIAProductsTrackingIdPrefix}search-product-catalog`,

  RIGHTS_OPEN_SETTINGS_LINK: `${UIARightsTrackingIdPrefix}open-settings-link`,
  RIGHTS_OPEN_USER_WEB_LINK: `${UIARightsTrackingIdPrefix}open-user-web-link`,
  RIGHTS_REQUEST_BACK: `${UIARightsTrackingIdPrefix}request-back`,
  RIGHTS_REQUEST_COMMENT_REQUEST_BUTTON: `${UIATrackingIdPrefix}comment-request-button`,
  RIGHTS_REQUEST_DIRECT_MESSAGE_BUTTON: `${UIATrackingIdPrefix}direct-message-button`,
  RIGHTS_REQUEST_DONE: `${UIARightsTrackingIdPrefix}request-done`,
  RIGHTS_REQUEST_EXTEND_RIGHTS_REQUEST_BUTTON: `${UIARightsTrackingIdPrefix}extend-rights-request-button`,
  RIGHTS_REQUEST_HASHTAG_SELECT: `${UIARightsTrackingIdPrefix}request-hashtag-select`,
  RIGHTS_REQUEST_MANAGE_RIGHTS_LEARN_MORE_LINK: `${UIARightsTrackingIdPrefix}manage-rights-learn-more-link`,
  RIGHTS_REQUEST_PATH_CONTINUE: `${UIARightsTrackingIdPrefix}request-path-continue`,
  RIGHTS_REQUEST_PATH_SKIP: `${UIARightsTrackingIdPrefix}request-path-skip`,
  RIGHTS_REQUEST_REQUEST_AGAIN_BUTTON: `${UIARightsTrackingIdPrefix}request-again-button`,
  RIGHTS_REQUEST_REQUEST: `${UIARightsTrackingIdPrefix}request-request`,
  RIGHTS_REQUEST_TEXT_CHANGE: `${UIARightsTrackingIdPrefix}request-text-change`,
  RIGHTS_REQUEST_TEXT_CLEAR: `${UIARightsTrackingIdPrefix}request-text-clear`,
  RIGHTS_REQUEST_TEXT_GENERATE: `${UIARightsTrackingIdPrefix}request-text-generate`,
  RIGHTS_REQUEST_TYPE_COMMENTS: `${UIARightsTrackingIdPrefix}request-type-comments`,
  RIGHTS_REQUEST_TYPE_DM: `${UIARightsTrackingIdPrefix}request-type-dm`,
  RIGHTS_REQUEST_TIKTOK_COMMENT_REQUEST_BUTTON: `${UIATrackingIdPrefix}tiktok-comment-request-button`,
  RIGHTS_REQUEST_TIKTOK_EXTEND_RIGHTS_REQUEST_BUTTON: `${UIARightsTrackingIdPrefix}tiktok-extend-rights-request-button`,

  SHARE: `${UIATrackingIdPrefix}share`,
  SHARE_CANCEL: `${UIAShareTrackingIdPrefix}cancel`,
  SHARE_CONFIRM: `${UIAShareTrackingIdPrefix}confirm`,
  SHARE_FORCE_REVIEW: `${UIAShareTrackingIdPrefix}force-review`,
  SHARE_WITHOUT_PRODUCTS_MODAL: `${UIAShareTrackingIdPrefix}without-products-modal`,
} as const satisfies Record<string, TrackingId>;

export const UIA_RIGHTS_REQUEST_PERMISSION =
  'universal_image_actions:request_rights';

export const DEFAULT_FRAMES_PER_SECOND = 30;
export const VIDEO_OFFSET_CONVERSION_FACTOR = 1000;
export const UIA_CUSTOM_COVER_SELECTION_PREVIEW_ASPECT_RATIO_PORTRAIT = 9 / 16;
export const UIA_CUSTOM_COVER_SELECTION_PREVIEW_ASPECT_RATIO_SQUARE = 1;
export const UIA_CUSTOM_COVER_SELECTION_PREVIEW_MAX_HEIGHT = 320;
export const UIA_CUSTOM_COVER_IMAGE_MAX_WIDTH = 240;
export const UIA_CUSTOM_COVER_UPLOAD_LIMIT = 8 * 1024 * 1024; // 8MB
const UIA_CUSTOM_COVER_PREFIX = 'Select the cover image for your video by ';
const UIA_CUSTOM_COVER_METHOD_DRAG = 'dragging to the desired timestamp';
const UIA_CUSTOM_COVER_METHOD_UPLOAD = 'uploading an image';
export const UIA_CUSTOM_COVER_DESCRIPTION = UIA_CUSTOM_COVER_PREFIX;
export const UIA_CUSTOM_COVER_DRAG_DESCRIPTION = `${UIA_CUSTOM_COVER_PREFIX}${UIA_CUSTOM_COVER_METHOD_DRAG}.`;
export const UIA_CUSTOM_COVER_UPLOAD_DESCRIPTION = `${UIA_CUSTOM_COVER_PREFIX}${UIA_CUSTOM_COVER_METHOD_UPLOAD}.`;
export const UIA_CUSTOM_COVER_DRAG_UPLOAD_DESCRIPTION = `${UIA_CUSTOM_COVER_PREFIX}either ${UIA_CUSTOM_COVER_METHOD_DRAG} or ${UIA_CUSTOM_COVER_METHOD_UPLOAD}.`;
export const UIA_CUSTOM_COVER_UPLOAD_HELP_TEXT =
  'Upload a custom cover image for your video. This will replace the current thumbnail for gallery.';
export const UIA_CUSTOM_COVER_UPLOAD_SIZE_ERROR =
  'Custom cover images for video must be less than 8MB.';
export const UIA_SLIDER_DEBOUNCE_DELAY_MS = 300;
